module.exports = __webpack_public_path__ + "images/nav/ico-help.png";